import React from 'react';

interface Props {
  onRefresh?: () => any;
  children?: React.ReactNode;
  isWindowLoad?: boolean;
  refreshColor?: string;
  containerStyle?: React.CSSProperties;
}
const WrapRefresh = ({ children, onRefresh, isWindowLoad, refreshColor = '#37D2D2', containerStyle = {} }: Props) => {
  const [startPoint, setStartPoint] = React.useState(0);
  const [pullChange, setPullChange] = React.useState<number>(0);
  /**
   ref to target the `.refresh-container` element in the DOM
  */
  const refreshCont = React.useRef<any>(0);

  const initLoading = () => {
    refreshCont.current.classList.add('loading');
    onRefresh && onRefresh();
    if (isWindowLoad) {
      window.location.reload();
    }
    console.log('Refreshing...');
  };

  const pullStart = (e: TouchEvent) => {
    const { screenY } = e.targetTouches[0];
    setStartPoint(screenY);
  };

  const pull = (e: TouchEvent) => {
    /**
     * get the current user touch event data
     */
    const touch = e.targetTouches[0];
    /**
     * get the touch position on the screen's Y axis
     */
    const { screenY } = touch;
    /**
     * The length of the pull
     *
     * if the start touch position is lesser than the current touch position, calculate the difference, which gives the `pullLength`
     *
     * This tells us how much the user has pulled
     */
    const pullLength = startPoint < screenY ? Math.abs(screenY - startPoint) : 0;
    setPullChange(pullLength);
    // console.log({ screenY, startPoint, pullLength, pullChange });
  };

  const endPull = (_: TouchEvent) => {
    setStartPoint(0);
    setPullChange(0);
    if (pullChange > 220) initLoading();
  };

  React.useEffect(() => {
    window.addEventListener('touchstart', pullStart);
    window.addEventListener('touchmove', pull);
    window.addEventListener('touchend', endPull);
    return () => {
      window.removeEventListener('touchstart', pullStart);
      window.removeEventListener('touchmove', pull);
      window.removeEventListener('touchend', endPull);
    };
  });

  return (
    <>
      <div
        ref={refreshCont}
        className="refresh-container w-fit bg-transparent m-auto mt-14 absolute left-0 right-0"
        style={{ top: 0, zIndex: pullChange ? 11 : -1, ...containerStyle }}
      >
        <div className="refresh-icon p-2 rounded-full">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke={refreshColor}
            className="w-6 h-6"
            style={{ transform: `rotate(${pullChange}deg)` }}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
            />
          </svg>
        </div>
      </div>
      {children}
    </>
  );
};

export default WrapRefresh;
